<template>
    <div id="status-attendance-page">
        <!-- HEADER -->
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.checkInLocation.searchSuggestion')"
                        solo
                        class="subheader-margin"
                        height="40px"
                        @keyup.enter="filterCheckInLocationList()">
                    </v-text-field>
                </div>
                <div class="ml-3">
                    <v-btn
                        @click="filterCheckInLocationList()"
                        class="subheader-margin"
                        color="primary"
                        height="40px"
                        outlined>
                        {{ $vuetify.lang.t('$vuetify.checkInLocation.search')}}
                    </v-btn>
                </div>
                <div class="ml-3 date-picker-input">
                    <span class="date-picker-label">
                        {{ $vuetify.lang.t('$vuetify.checkInLocation.startDate') }}
                    </span>
                    <v-menu
                        v-model="startDatePickerShow"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="234px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="startDateFormatted"
                                prepend-inner-icon="event"
                                @click:prepend-inner="startDatePickerShow = true"
                                @click:clear="startDate = null"
                                readonly
                                v-on="on"
                                solo
                                height="40px"
                                background-color="#ffffff">
                            </v-text-field>
                        </template>
                        <v-date-picker
                            :locale="localeLang"
                            v-model="startDate"
                            @change="formatStartDate"
                            @input="startDatePickerShow = false">
                        </v-date-picker>
                    </v-menu>
                </div>
                <div class="ml-3 date-picker-input">
                    <span class="date-picker-label">
                        {{ $vuetify.lang.t('$vuetify.checkInLocation.endDate') }}
                    </span>
                    <v-menu
                        v-model="endDatePickerShow"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="234px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="endDateFormatted"
                                :label="$vuetify.lang.t('$vuetify.checkInLocation.endDate')"
                                prepend-inner-icon="event"
                                @click:clear="endDate = null"
                                @click:prepend-inner="endDatePickerShow = true"
                                readonly
                                v-on="on"
                                solo
                                height="40px"
                                background-color="#ffffff">
                            </v-text-field>
                        </template>
                        <v-date-picker
                            :locale="localeLang"
                            v-model="endDate"
                            @change="formatEndDate"
                            @input="endDatePickerShow = false">
                        </v-date-picker>
                    </v-menu>
                </div>
            </div>
            <div class="ml-3 export-button-container">
                <v-btn
                    class="subheader-margin export-font-size"
                    color="primary"
                    height="40px"
                    @click="getReport('excel')">
                    <span class="mr-2">
                        <i class="far fa-file-excel"></i>
                    </span>
                    {{ $vuetify.lang.t('$vuetify.checkInLocation.exportExcel')}}
                </v-btn>
                <!-- <v-btn
                    class="subheader-margin export-font-size ml-3"
                    color="primary"
                    height="40px"
                    @click="getReport('pdf')">
                    <span class="mr-2">
                        <i class="far fa-file-pdf"></i>
                    </span>
                    {{ $vuetify.lang.t('$vuetify.checkInLocation.exportPdf')}}
                </v-btn> -->
            </div>
        </div>
        <!-- END HEADER -->
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="total"
                :items="checkInLocationList"
                :loading="loading">
                <template v-slot:[`item.address`]="{ item }">
                    <span @click="goToDetailsPage(item.id)">
                        <i class="fas pin-location fa-map-marker-alt"></i>
                    </span>
                    <span>
                        {{ item.address }}
                    </span>
                </template>
            </v-data-table>
        </v-card>

        <div
            v-if="pageCount"
            class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ForgotCheckInReq',

    data () {
        return {
            loading: false,
            total: 0,
            checkInLocationList: [],
            pageCount: 1,
            page: 1,
            options: {},
            search: '',
            startDate: this.$util.getCurrentDate(),
            endDate: this.$util.getCurrentDate(),
            startDatePickerShow: false,
            endDatePickerShow: false,
            startDateFormatted: '',
            endDateFormatted: '',
            branch: null
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },

        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.checkInLocation.employeeNo'), value: 'employee__employee_no', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.checkInLocation.employeeName'), value: 'employee__fullname', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.checkInLocation.date'), value: 'date', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.checkInLocation.time'), value: 'time', width: '15%' },
                { text: '', value: 'address', width: '35%' }
            ]
        }
    },

    methods: {
        async getCheckInLocationList () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `attendances/check-in-location?branch=${this.branch}&page=${page}&itemsPerPage=${itemsPerPage}`
            if (sortBy && sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc && sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            if (this.startDate) {
                url += `&startDate=${this.startDate}`
            }

            if (this.endDate) {
                url += `&endDate=${this.endDate}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.checkInLocationList = res.data.data
                this.total = res.data.total
                this.loading = false
            }
        },

        formatStartDate () {
            this.startDateFormatted = this.$util.formatDate(this.startDate)
        },

        formatEndDate () {
            this.endDateFormatted = this.$util.formatDate(this.endDate)
        },

        async getBranch () {
            this.branch = localStorage.getItem('currentBranchId')
            if (this.branch) {
                await this.getCheckInLocationList()
            }
        },

        async filterCheckInLocationList () {
            this.options.page = 1
            await this.getCheckInLocationList()
        },

        goToDetailsPage (checkInLocationId) {
            this.$router.push({ name: 'CheckInLocationDetail', params: { id: checkInLocationId } }, () => {})
        },

        async genExcelReport (body) {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.post('report/check-in-location/excel', body, {
                headers: {
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                },
                responseType: 'arraybuffer'
            })

            if (res && res.data) {
                this.$util.downloadExcelFile(res.data, 'Line-checkin-report.xls')
                this.$store.dispatch('setLoading', false)
            }
        },

        async genPdfReport (body) {
            this.$store.dispatch('setLoading', true)
            const response = await this.axios.post('report/check-in-location/pdf', body, {
                headers: {
                    'Content-Type': 'application/pdf'
                },
                responseType: 'arraybuffer'
            })

            if (response && response.data) {
                this.$util.downloadPdfFile(response.data)

                this.$store.dispatch('setLoading', false)
            }
        },

        async getReport (reportType) {
            const { sortBy, sortDesc } = this.options
            let sortByForReport = null
            if (sortBy && sortBy[0]) {
                sortByForReport = sortBy[0]
            }

            let sortDescForRreport = null
            if (sortDesc && sortDesc[0]) {
                sortDescForRreport = sortDesc[0]
            }

            const body = {
                branchId: this.branch,
                startDate: this.startDate,
                endDate: this.endDate,
                search: this.search,
                sortBy: sortByForReport,
                sortDesc: sortDescForRreport
            }

            this.$store.dispatch('setLoading', true)
            if (reportType === 'excel') {
                this.genExcelReport(body)
            } else if (reportType === 'pdf') {
                this.genPdfReport(body)
            }
        }
    },

    async mounted () {
        await this.getBranch()
        this.formatStartDate()
        this.formatEndDate()
    },

    watch: {
        options: {
            async handler () {
                if (this.branch) {
                    await this.getCheckInLocationList()
                }
            },
            deep: true
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                if (this.branch) {
                    await this.getCheckInLocationList()
                }
                await this.getCheckInLocationList()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
}
::v-deep .search-input .v-input__control > .v-input__slot {
    box-shadow: none !important;
    border: 1px solid #a8a8a8 !important;
}

.search-input {
    width: 40%;
}

.pointer {
    cursor: pointer;
}

.date-picker-label {
    font-size: 12px;
    color: #757575;
}

.subheader-margin {
    margin-top: 24px;
}

.action-header {
    margin-top: 0.5rem;
}

.pin-location {
    color: #d76436;
    margin-right: 5px;
    cursor: pointer;
}

.export-font-size {
    font-family: LexendDeca;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
}

.export-button-container {
    width: 44%;
    display: flex;
    justify-content: flex-end;
}

::v-deep .date-picker-input {
    width: 25%;

    .v-input__append-inner {
        margin-top: 11px;
    }
}
</style>
